import { useState } from "react";
import { Button } from "Components/Button";
import { useParams } from "react-router";
import { useQuery } from "react-query";
import { listProductsOnBudgetsCart } from "Requests/Partners/Budgets";
import { ChooseProducts } from "./ChoseProducts";
import { Documents } from "./Document";

export const Tabs = () => {
  const [tab, setTab] = useState<"products" | "files">("products");

  const { id } = useParams<{ id: string }>();

  const { data } = useQuery({
    queryFn: () => listProductsOnBudgetsCart(Number(id)),
    queryKey: ["budget-cart-items", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const files = data?.files
    ? data?.files.map((file) => ({
        file_path: file,
      }))
    : [];

  return (
    <div>
      <div className="tabs">
        <Button
          onClick={() => setTab("products")}
          outlined={tab !== "products"}
        >
          Visualizar produtos
        </Button>
        {data?.files && data?.files.length >= 1 && (
          <Button onClick={() => setTab("files")} outlined={tab !== "files"}>
            Visualizar Pedidos Médicos
          </Button>
        )}
      </div>
      {tab === "products" && <ChooseProducts />}

      {tab === "files" && files.length >= 1 && (
        <div className="documents">
          <Documents files={files} />
        </div>
      )}
    </div>
  );
};
